// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2puxp","toggleWrap":"styles_toggleWrap__1c8dL","content":"styles_content__1glr5","selectAreaCode":"styles_selectAreaCode__10jMv"};